import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { ArrowRight, ArrowDown } from 'lucide-react';
export function SolutionSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="w-full bg-navy py-24 px-4 sm:px-6 lg:px-8" data-id="element-200">
      <div ref={ref} className={`max-w-6xl mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-201">
        <div className="text-center mb-16" data-id="element-202">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-4" data-id="element-203">
            LA SOLUCIÓN DEFINITIVA
          </span>
          <h2 className="font-playfair font-bold text-3xl sm:text-[46px] leading-[1.2] text-white" data-id="element-204">
            No Compres Más Material de Otros.
            <br data-id="element-205" />
            Aprendé a Crear el Tuyo.
            <br data-id="element-206" />
            <span className="relative inline-block mt-2" data-id="element-207">
              Para Siempre.
              <span className="absolute -bottom-2 left-0 w-full h-1.5 bg-gold rounded-full" data-id="element-208"></span>
            </span>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-4 relative" data-id="element-209">
          {/* Step 1 */}
          <div className="flex-1 flex flex-col items-center text-center z-10" data-id="element-210">
            <div className="w-20 h-20 rounded-full bg-gold flex items-center justify-center mb-6 shadow-lg shadow-gold/20" data-id="element-211">
              <span className="font-montserrat font-black text-3xl text-navy" data-id="element-212">
                01
              </span>
            </div>
            <h3 className="font-playfair font-bold text-2xl text-white mb-3" data-id="element-213">
              Aprendés el Sistema
            </h3>
            <p className="font-inter text-[#A8B2D8] max-w-xs" data-id="element-214">
              Dominás el método exacto para pedirle a la IA lo que necesitás
            </p>
          </div>

          {/* Arrow 1 */}
          <div className="hidden md:flex text-gold animate-pulse" data-id="element-215">
            <ArrowRight size={40} strokeWidth={1.5} data-id="element-216" />
          </div>
          <div className="md:hidden text-gold animate-pulse" data-id="element-217">
            <ArrowDown size={40} strokeWidth={1.5} data-id="element-218" />
          </div>

          {/* Step 2 */}
          <div className="flex-1 flex flex-col items-center text-center z-10" data-id="element-219">
            <div className="w-20 h-20 rounded-full bg-electric flex items-center justify-center mb-6 shadow-lg shadow-electric/20" data-id="element-220">
              <span className="font-montserrat font-black text-3xl text-white" data-id="element-221">
                02
              </span>
            </div>
            <h3 className="font-playfair font-bold text-2xl text-white mb-3" data-id="element-222">
              Aplicás los Prompts
            </h3>
            <p className="font-inter text-[#A8B2D8] max-w-xs" data-id="element-223">
              Usás nuestro Banco de Prompts diseñado pedagógicamente para
              docentes
            </p>
          </div>

          {/* Arrow 2 */}
          <div className="hidden md:flex text-gold animate-pulse" data-id="element-224">
            <ArrowRight size={40} strokeWidth={1.5} data-id="element-225" />
          </div>
          <div className="md:hidden text-gold animate-pulse" data-id="element-226">
            <ArrowDown size={40} strokeWidth={1.5} data-id="element-227" />
          </div>

          {/* Step 3 */}
          <div className="flex-1 flex flex-col items-center text-center z-10" data-id="element-228">
            <div className="w-20 h-20 rounded-full bg-emerald flex items-center justify-center mb-6 shadow-lg shadow-emerald/20" data-id="element-229">
              <span className="font-montserrat font-black text-3xl text-white" data-id="element-230">
                03
              </span>
            </div>
            <h3 className="font-playfair font-bold text-2xl text-white mb-3" data-id="element-231">
              Creás tu Material
            </h3>
            <p className="font-inter text-[#A8B2D8] max-w-xs" data-id="element-232">
              Generás planificaciones, actividades y evaluaciones en 10 minutos.
              Para siempre.
            </p>
          </div>
        </div>
      </div>
    </section>;
}